import { session } from './session'

export function updateViewedProducts(sku: string) {
  const prev = session.viewedProducts.get(',') ?? []
  const skus = new Set(prev)

  if (skus.has(sku)) skus.delete(sku)
  skus.add(sku)

  const next = [...skus].reverse().join(',')
  session.viewedProducts.set(next)
}

export function updateViewedProductsByHandle(handle: string) {
  const prev = session.viewedProducts.get(',') ?? []
  const handles = new Set(prev)

  if (handles.has(handle)) handles.delete(handle)
  handles.add(handle)

  const next = [...handles].reverse().join(',')
  session.viewedProducts.set(next)
}
